import {
    get,
    post,
    del,
    patch
} from './twice'
// 获取首页数据参数
export const gethome = (data) => post('/home', data);
// 获取关于我们页数据内容
export const getaboutus = (data) => post('/aboutus', data);
// 获取资讯列表内容
export const newslist = (data) => post('/news/list', data);
// 获取资讯详细页内容
export const newsdetail = (newid) => post(`/news/${newid}`);
// 获取活动模块信息
export const activity = (data) => post('/activity', data)
// 获取加入我们模块信息
export const joinus = (data) => post('/joinus', data)
// 加入我们-用户提交表单
export const submit_form = (data) => post('/joinus/submit_form', data)
// 联系我们-设置信息
export const contactus = (data) => post("/contactus", data)
// 图片一览
export const picture_overview = (data) => post("/picture_overview", data)
// 申请表单
export const application_forms = (data) => post("/application_forms", data)
// 核销码
export const verification_qrcode = (data) => post("/verification_qrcode", data)
// 列表数据
export const application_forms_list = (data) => post("/application_forms_list", data)